export default __webpack_public_path__ + "static/media/swagger.ebdad154.png";